import { Series } from './../../../../models';
import { ActivatedRoute, Router } from '@angular/router';
import { SeriesService } from './../../../../services/series.service';
import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/internal/operators/first';
import { Title } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as jquery from 'jquery';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'series-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class SeriesListingComponent implements OnInit {

  series: Series[] = [];
  seriesId: number;
  seriesName: string;
  seriesStatus: string;
  seriesSequence: number;
  addSeriesForm: FormGroup;
  editSeriesForm: FormGroup;
  submitted = false;
  loading = false;
  modalText = 'Loading...';
  error = false;
  submitError = false;
  submitErrorMsg = '';

  constructor(
    private seriesService: SeriesService,
    private pageTitleService: Title,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.setFormControls();

    // Enables to reload current route
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    this.loadData();
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Series & Modules');
  }

  // Convenience getter for easy access to form fields
  get f() { return this.addSeriesForm.controls; }

  get editF() { return this.editSeriesForm.controls; }

  setFormControls() {
    this.addSeriesForm = new FormGroup({
      seriesName: new FormControl('', [
        Validators.required,
        Validators.minLength(5)
      ])
    });

    this.editSeriesForm = new FormGroup({
      seriesName: new FormControl('', [
        Validators.required,
        Validators.minLength(5)
      ]),
      seriesSequence: new FormControl('', [
        Validators.required,
        Validators.minLength(1)
      ])
    });
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.seriesService.getSeriesAdmin()
    .pipe(
      map(seriesData => seriesData.data),
      tap(seriesData => {
        this.series = [];
        seriesData.series.forEach((series, key) => {
          seriesData.series[key].status = this.capitalizeFirstCharacter(seriesData.series[key].status);
          this.series.push(series);
        });
        if (this.series.length > 0) {
          this.series.sort(this.sortByValues);
        }
      }),
    )
    .subscribe(
      response => {
        if (response) {
          setTimeout(() => {
            // hide progress modal
            this.hideProgressModal();
          }, 500);
        }
      },
      error => {
        // hide progress modal
        this.hideProgressModal();
        this.error = true;
      }
    );
  }

  resetForm() {
    this.addSeriesForm.reset();
    this.f.seriesName.setValue('');
    this.f.seriesName.setErrors({invalid: false});
    this.f.seriesName.setErrors({error: false});
  }

  showEditSeries(seriesId: number) {
    this.seriesService.getSeriesModulesAdmin(seriesId)
      .subscribe(
        seriesData => {
          if (seriesData.success) {
            if (seriesData.data.modules.length > 0) {
              this.router.navigate(['/admin/series/' + seriesId + '/1']);
            } else {
              this.router.navigate(['/admin/series/' + seriesId + '/0']);
            }
          }
        },
        error => { }
      );
  }

  onSubmit() {
    this.submitted = true;
    this.loading = true;

    // Stop here if there's form errors
    if (this.addSeriesForm.invalid) {
      this.loading = false;
      return;
    }

    this.seriesService.addSeries(this.f.seriesName.value)
      .pipe(first())
      .subscribe(
        seriesData => {
          if (seriesData.success) {
            this.router.navigate(['/admin/series']);
            const closeModalButton: HTMLElement = document.getElementById('close-addSeries-modal');
            closeModalButton.click();
            this.loading = false;
          }
        },
        error => {
          this.error = true;
        }
      );

  }

  getSeriesAttributes(data: any) {
    this.seriesId = data?.id;
    this.seriesName = data?.title;
    this.seriesSequence = data?.sequence;
    this.seriesStatus = data?.status;

    this.editF.seriesName.setValue(data?.title);
    this.editF.seriesSequence.setValue(data?.sequence);

    // Resets Submit Error
    this.submitError = false;

    jquery('#showEditModal').trigger('click');

  }

  updateSeries() {
    this.submitted = true;

    // Stop here if there's form errors
    if (this.editSeriesForm.invalid) {
        return;
    }

    this.seriesService.updateSeries(
      this.seriesId,
      this.editF.seriesName.value,
      this.editF.seriesSequence.value,
      this.seriesStatus.toLowerCase()
    )
      .pipe(first())
      .subscribe(
        seriesData => {
          setTimeout(() => {
            const closeModalButton: HTMLElement = document.getElementById('close-editSeries-modal');
            closeModalButton.click();
          }, 0);

          if (seriesData.success) {
            this.submitted = false;
            this.loadData();
          }
        },
        error => {
          this.submitError = true;
          this.submitted = false;
          this.submitErrorMsg = 'An error occurred when submitting form data.';
        }
      );

  }

  private capitalizeFirstCharacter(status: string) {
    return status.charAt(0).toUpperCase() + status.slice(1);
  }

  private sortByValues(a, b) {
    const bandA = a.sequence;
    const bandB = b.sequence;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }


}
